"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
var STRINGS = {
  FLIP_MANDATORY_NOT_READ: {
    de: 'Um diesen Abschnitt zu bearbeiten, drehe bitte alle Grafiken per Klick – wie beim Memory Spiel – um, um mehr über das Thema zu erfahren.'
  },
  FLIP_MANDATORY_READ: {
    de: 'Drehe – wie beim Memory spielen – Grafiken per Klick um, um mehr über das Thema zu erfahren.'
  },
  FLIP_NOT_MANDATORY: {
    de: 'Drehe – wie beim Memory spielen – Grafiken per Klick um, um mehr über das Thema zu erfahren. Dieser Abschnitt muss nicht bearbeitet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  HTML_MANDATORY_NOT_READ: {
    de: 'Bei diesem Symbol erwartet Dich Text, Bild oder eine Kombination aus beidem. Um diesen Abschnitt zu bearbeiten, sieht Dir bitte die Inhalte an.'
  },
  HTML_MANDATORY_READ: {
    de: 'Bei diesem Symbol erwartet Dich Text, Bild oder eine Kombination aus beidem.'
  },
  HTML_NOT_MANDATORY: {
    de: 'Bei diesem Symbol erwartet Dich Text, Bild oder eine Kombination aus beidem. Dieser Abschnitt muss nicht bearbeitet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  LIST_MANDATORY_NOT_READ: {
    de: 'In dieser Auflistung erhältst Du weitergehende Informationen durch Klick auf das Pfeil-Symbol am Zeilenende. Bitte sieh Dir alle Listeneinträge an, damit dieser Abschnitt als bearbeitet gilt.'
  },
  LIST_MANDATORY_READ: {
    de: 'In dieser Auflistung erhältst Du weitergehende Informationen durch Klick auf das Pfeil-Symbol am Zeilenende.'
  },
  LIST_NOT_MANDATORY: {
    de: 'In dieser Auflistung erhältst Du weitergehende Informationen durch Klick auf das Pfeil-Symbol am Zeilenende. Diese Auflistung muss nicht bearbeitet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  PDF_MANDATORY_NOT_READ: {
    de: 'Bitte öffne das PDF-Dokument, damit dieser Abschnitt als bearbeitet gilt.'
  },
  PDF_MANDATORY_READ: {
    de: 'Hier erhältst Du Informationen zum Abspeichern und Ausdrucken im PDF-Format.'
  },
  PDF_NOT_MANDATORY: {
    de: 'Hier erhältst Du Informationen zum Abspeichern und Ausdrucken im PDF-Format. Das Dokument muss nicht geöffnet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  QUIZ_MANDATORY_NOT_READ: {
    de: 'Bei diesem Symbol wirst Du auf die Probe gestellt: Teste Dein Wissen. Beantworte bitte alle Fragen, damit dieser Abschnitt als bearbeitet gilt.'
  },
  QUIZ_MANDATORY_READ: {
    de: 'Bei diesem Symbol wirst Du auf die Probe gestellt: Teste Dein Wissen.'
  },
  QUIZ_NOT_MANDATORY: {
    de: 'Bei diesem Symbol wirst Du auf die Probe gestellt: Teste Dein Wissen. Der Abschnitt muss nicht bearbeitet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  SWIPE_MANDATORY_NOT_READ: {
    de: 'Damit dieser Abschnitt als bearbeitet gilt, blättere bitte per Klick auf die Pfeile durch alle Informationen.'
  },
  SWIPE_MANDATORY_READ: {
    de: 'Durch Klick auf die Pfeile erhältst Du weitere Inhalte als Info-Galerie.'
  },
  SWIPE_NOT_MANDATORY: {
    de: 'Durch Klick auf die Pfeile erhältst Du weitere Inhalte als Info-Galerie. Die Info-Galerie muss nicht bearbeitet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  URL_MANDATORY_NOT_READ: {
    de: 'Damit dieser Abschnitt als bearbeitet gilt, schaue Dir die angezeigte Internetseite an.'
  },
  URL_MANDATORY_READ: {
    de: 'Bei diesem Symbol erhältst Du weitere Informationen über die angezeigte Internetseite.'
  },
  URL_NOT_MANDATORY: {
    de: 'Bei diesem Symbol erhältst Du weitere Informationen per Internetseite. Die Seite muss nicht angeschaut werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  VIDEO_MANDATORY_NOT_READ: {
    de: 'Damit dieser Abschnitt als bearbeitet gilt, sieh Dir bitte das Video an. Ein Anspielen ist ausreichend, aber für einen optimalen Lernerfolg solltest Du Dir den gesamten Inhalt aufmerksam ansehen.'
  },
  VIDEO_MANDATORY_READ: {
    de: 'Hier erwartet Dich ein Video.'
  },
  VIDEO_NOT_MANDATORY: {
    de: 'Hier erwartet Dich ein Video. Der Abschnitt muss nicht bearbeitet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  VOTE_MANDATORY_NOT_READ: {
    de: 'Deine Meinung ist gefragt. Damit dieser Abschnitt als bearbeitet gilt, stimme anonym ab und sieh Dir an, welcher Meinung die anderen Teilnehmer waren.'
  },
  VOTE_MANDATORY_READ: {
    de: 'Deine Meinung ist gefragt. Stimme anonym ab und sieht Dir an, welcher Meinung die anderen Teilnehmer waren.'
  },
  VOTE_NOT_MANDATORY: {
    de: 'Deine Meinung ist gefragt. Stimme anonym ab und sieh Dir an, welcher Meinung die anderen Teilnehmer waren. Das Voting muss nicht bearbeitet werden, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  RUBRIC_MANDATORY_NOT_READ: {
    de: 'Buche einen Termin in diesem Veranstaltungsthema, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  RUBRIC_MANDATORY_READ: {
    de: 'Bitte wähle das Veranstaltungsthema aus, das Dich interessiert.'
  },
  RUBRIC_NOT_MANDATORY: {
    de: 'Bitte wähle das Veranstaltungsthema aus, das Dich interessiert.'
  },
  EVENTSERIES_MANDATORY_NOT_READ: {
    de: 'Buche einen Termin in dieser Veranstaltungsreihe, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  EVENTSERIES_MANDATORY_READ: {
    de: 'Bitte wähle die Veranstaltungsreihe aus, an der Du teilnehmen möchtest.'
  },
  EVENTSERIES_NOT_MANDATORY: {
    de: 'Bitte wähle die Veranstaltungsreihe aus, an der Du teilnehmen möchtest.'
  },
  FEEDBACK_MANDATORY_NOT_READ: {
    de: 'Gib Feedback ab, um den Zustand "Bearbeitet" für die Lektion zu erreichen.'
  },
  FEEDBACK_MANDATORY_READ: {
    de: 'Hier kannst Du Feedback abgeben.'
  },
  FEEDBACK_NOT_MANDATORY: {
    de: 'Hier kannst Du Feedback abgeben.'
  },
  FLIP_INFO: {
    de: 'Drehe – wie beim Memoryspielen – Grafiken per Klick um, um mehr über das Thema zu erfahren.'
  },
  HTML_INFO: {
    de: 'Bei diesem Symbol erwartet Dich Text, Bild oder eine Kombination aus beidem.'
  },
  LIST_INFO: {
    de: 'In dieser Auflistung erhältst Du weitergehende Informationen durch Klick auf das Pfeil-Symbol am Zeilenende.'
  },
  PDF_INFO: {
    de: 'Hier erhältst Du Informationen zum Abspeichern und Ausdrucken im PDF-Format.'
  },
  QUIZ_INFO: {
    de: 'Bei diesem Symbol wirst Du auf die Probe gestellt: Teste Dein Wissen.'
  },
  SWIPE_INFO: {
    de: 'Durch Klick auf die Pfeile erhältst Du weitere Inhalte als Info-Galerie.'
  },
  URL_INFO: {
    de: 'Bei diesem Symbol erhältst Du weitere Informationen über die angezeigte Internetseite.'
  },
  VIDEO_INFO: {
    de: 'Hier erwartet Dich ein Video.'
  },
  VOTE_INFO: {
    de: 'Deine Meinung ist gefragt. Stimme anonym ab und sieht Dir an, welcher Meinung die anderen Teilnehmer waren.'
  },
  RUBRIC_INFO: {
    de: 'Bitte wähle das Veranstaltungsthema aus, das Dich interessiert.'
  },
  EVENTSERIES_INFO: {
    de: 'Bitte wähle die Veranstaltungsreihe aus, an der Du teilnehmen möchtest.'
  },
  FEEDBACK_INFO: {
    de: 'Hier kannst Du Feedback abgeben.'
  },
  USER_DATA: {
    de: 'Benutzerkonto anlegen'
  },
  USER_DATA_EXPLANATION: {
    de: 'Bitte wähle Deinen persönlichen Nutzernamen und Dein Passwort für den Zugang zum Lernprogramm.'
  },
  UNAUTHORIZED_MESSAGE: {
    de: 'Du hast Dich auf einem anderen Gerät angemeldet. Bitte melde Dich neu an, um hier weiter zu arbeiten.'
  },
  LOGIN: {
    de: 'Anmeldung'
  },
  MC_ALL_CORRECT: {
    de: 'Du hast alle richtigen Antworten ausgewählt<br><br>$0',
    en: 'All correct answers selected<br><br>$0'
  },
  MC_NOT_ENOUGH_CHOSEN: {
    de: 'Du hast zu wenige Antworten ausgewählt.<br><br>$0',
    en: 'Not enough answers selected<br><br>$0'
  },
  MC_NOT_ALL_RIGHT: {
    de: 'Nicht alle ausgewählten Antworten waren richtig.<br><br>$0',
    en: 'Not all selected answers are correct.<br><br>$0'
  },
  MC_TOO_MUCH_CHOSEN: {
    de: 'Du hast zu viele Antworten ausgewählt.<br><br>$0',
    en: 'Too much answers selected.<br><br>$0'
  },
  ERROR_LOADING_CONTENT: {
    de: 'Der Inhalt konnte nicht geladen werden. Bitte überprüfe Deine Internetverbindung oder probiere es später noch mal.',
    en: 'Error loading content. Please check your internet connection or try again later.'
  },
  NO_OPTION_CHOSEN: {
    de: 'Bitte wähle mindestens eine Antwort aus.'
  },
  // Fehlermeldungen
  E_CODE_WRONG: {
    de: 'Aktivierungscode mit falschem Format angegeben.'
  },
  E_USER_NOTFOUND: {
    de: 'Unbekannter Nutzername.'
  },
  E_NICKNAME_WRONG_FORMAT: {
    de: 'Der Nutzername enthält ein nicht-erlaubtes Zeichen.'
  },
  E_NICKNAME_USED: {
    de: 'Der Nutzername ist bereits vergeben.'
  },
  E_NICKNAME_EMPTY: {
    de: 'Bitte trage einen Nutzernamen ein.'
  },
  E_NO_EMAIL: {
    de: 'Unbekannte E-Mail-Adresse.'
  },
  UNKNOWN_ERROR: {
    de: 'Schade, irgendetwas ist schief gelaufen.',
    en: 'Unknown Error'
  },
  ERROR_ON_CONTENT_UPDATE: {
    de: 'Schade, beim Aktualisieren der Inhalte ist etwas schief gelaufen.',
    en: 'An error occured while updating the content.'
  },
  ERROR: {
    de: 'Ups, etwas ist schief gelaufen...',
    en: 'Error'
  },
  USER_AGREEMENT_TEXT: {
    de: '<div style="text-align: justify; font-size:12pt; color:#5a5a5a"><p style="font-size:14pt"><b>Definitionen</b></p><p>Dienstanbieter im Sinne von § 2 TMG ist die</span></p><p>VR-LEASING Aktiengesellschaft<br />Hauptstraße 131-137<br />65760 Eschborn</span></p><p style="font-size:14pt"><b>Bestimmungsgemäßer Gebrauch</b></p><p>Die Inhalte der auf dieser Website bereitgestellten Trainingsprogramme sind ausschließlich zur innerbetrieblichen Fortbildung der Mitarbeiter des Dienstanbieters bestimmt. Der Zugang zu diesen Inhalten ist durch eine Nutzerkennung und ein individuelles Password geschützt. Das Weitergeben des Zugangs oder das – auch auszugsweise – kopieren der Inhalte ist untersagt.</p><p style="font-size:14pt"><b>Haftung für Inhalte</b></p><p>Die Inhalte dieser Webseite wurden sorgfältig und nach aktuellem Kenntnisstand erstellt. Die der Dienstanbieter ist für diese nur im Rahmen der allgemeinen Gesetze verantwortlich, insbesondere gemäß § 7 Abs. 1 TMG bzw. für fremde Inhalte gemäß §§ 8 bis 10 TMG. Für die fremden Inhalte ist der Dienstanbieter frühestens ab Kenntniserlangung einer konkreten&nbsp;Rechtsverletzung verantwortlich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p><p style="font-size:14pt"><b>Haftung für Links</b></p><p>Die Trainingsinhalte enthalten Links zu Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben, weshalb wir uns von diesen distanzieren bzw. uns diese nicht zu Eigen machen. Wir übernehmen für diese fremden Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p><p style="font-size:14pt"><b>Urheberrecht</b></p><p>Alle auf dieser Webseite erstellten Inhalte und Werke unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Urhebers bzw. Rechteinhabers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p></div>'
  }
};
var _default = STRINGS;
exports["default"] = _default;